import { AHNumberInput, Box } from "arkh";
import { UserLoggedInNavigatorScreenProps } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { useCallback } from "react";
import { graphql, useLazyLoadQuery, useMutation } from "react-relay";
import { TodoResponseNumberScreenQuery } from "./__generated__/TodoResponseNumberScreenQuery.graphql";
import { useDebouncedMutation } from "../../common/Utils/useDebouncedMutation";
import { TodoResponseNumberScreenMutation } from "./__generated__/TodoResponseNumberScreenMutation.graphql";

export function TodoResponseNumberScreen(
  props: UserLoggedInNavigatorScreenProps<"TodoResponseNumber">
) {
  const data = useLazyLoadQuery<TodoResponseNumberScreenQuery>(
    graphql`
      query TodoResponseNumberScreenQuery($todoId: ID!) {
        todo(id: $todoId) {
          id
          responseDescription
          response {
            ... on TodoResponseNumber {
              value
            }
          }
        }
      }
    `,
    {
      todoId: props.route.params.todoId,
    }
  );

  const [mutation] = useMutation<TodoResponseNumberScreenMutation>(graphql`
    mutation TodoResponseNumberScreenMutation(
      $todoId: ID!
      $input: UpdateTodoNumberResponseInput!
    ) {
      todo(todoId: $todoId) {
        updateNumberResponse(input: $input) {
          isResponseCompleted
          response {
            ... on TodoResponseNumber {
              value
            }
          }
        }
      }
    }
  `);

  const remoteValue = data.todo?.response?.value ?? undefined;
  const setValue = useCallback(
    (value: number | undefined) => {
      mutation({
        variables: {
          todoId: data.todo!.id,
          input: {
            number: value,
          },
        },
      });
    },
    [data.todo, mutation]
  );
  const [local, setR] = useDebouncedMutation(remoteValue, setValue);
  return (
    <Box space="small" color="background" cornerRadius="medium">
      <AHNumberInput
        buttonsShow={false}
        autoFocus
        inputContainerStyle={{
          width: null,
          flex: 1,
        }}
        space="small"
        cornerRadius="medium"
        value={local}
        setValue={setR}
        clearTextOnFocus
        disabled={false}
        maxValue={10000000000}
        minValue={0}
      />
    </Box>
  );
}
